const API = process.env.REACT_APP_API_URL;

const headers = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

// ================= GET Special Business Hours =================

export const getSpecialBusinessHours = async (token, noEmplacement) => {
  const res = await fetch(
    `${API}/SpecialBusinessHours/GetSpecialBusinessHours/${noEmplacement}`,
    {
      method: "GET",
      headers: headers(token),
    },
  );

  if (!res.ok) {
    const error = await res.json();
    throw error;
  }

  return res.json();
};

// ================= CREATE Special Business Hours =================

export const createSpecialBusinessHours = async (
  token,
  noEmplacement,
  payload,
) => {
  const res = await fetch(
    `${API}/SpecialBusinessHours/CreateSpecialBusinessHour/${noEmplacement}`,
    {
      method: "POST",
      headers: headers(token),
      body: JSON.stringify(payload),
    },
  );

  if (!res.ok) {
    const error = await res.json();
    throw error;
  }

  return res.json();
};
// ================= UPDATE Special Business Hours =================

// ================= UPDATE Special Business Hours =================

export const updateSpecialBusinessHours = async (
  token,
  noEmplacement,
  originalDate,
  payload,
) => {
  const res = await fetch(
    `${API}/SpecialBusinessHours/UpdateSpecialBusinessHour/${noEmplacement}/${originalDate}`,
    {
      method: "PUT",
      headers: headers(token),
      body: JSON.stringify(payload),
    },
  );

  if (!res.ok) {
    const error = await res.json();
    throw error;
  }

  return res.json();
};
// ================= DELETE Special Business Hours =================

export const deleteSpecialBusinessHours = async (
  token,
  noEmplacement,
  date,
) => {
  const res = await fetch(
    `${API}/SpecialBusinessHours/DeleteGetSpecialBusinessHour/${noEmplacement}/${date}`,
    {
      method: "DELETE",
      headers: headers(token),
    },
  );

  if (!res.ok) {
    const error = await res.json();
    throw error;
  }

  return res.json();
};
